
  declare var window: any;
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      window.locations ??= {};
      let d = window.wf.FindSalesPerson;
      d.selectedRegion ??= '';
      d.selectedRegionGroup ??= '';
      return d;
    },
    methods: {
      resetFilters() {
        this.selectedRegion = '';
        this.selectedRegionGroup = this.populatedRegionGroups[0].code;
      },
      updateFilters() {
        this.filteredRegions;
        this.filteredRegionsByRegionGroup;
      },
      changeSelectedRegionGroup() {
        this.selectedRegion = '';
        this.updateFilters();
      },
      phoneToLink(phoneText) {
        var tempLink = '';
        if (phoneText != '') {
          tempLink = '<a href="tel:' + phoneText + '">' + phoneText + '</a>';
        }
        return tempLink;
      }
    },
    computed: {
      filteredRegions() {
        var tempFilteredRegions = [...this.populatedRegions];
        if (this.selectedRegion !== '') {
          tempFilteredRegions = tempFilteredRegions.filter(region => region.code == this.selectedRegion);
        }
        if (this.selectedRegionGroup !== '') {
          tempFilteredRegions = tempFilteredRegions.filter(region => region.regiongroup == this.selectedRegionGroup);
        }
        return tempFilteredRegions;
      },
      filteredRegionsByRegionGroup() {
        var tempFilteredRegions = [...this.populatedRegions];
        if (this.selectedRegionGroup !== '') {
          tempFilteredRegions = tempFilteredRegions.filter(region => region.regiongroup == this.selectedRegionGroup);
        }
        return tempFilteredRegions;
      },
      populatedRegionGroups() {
        var tempPopulatedRegionGroups = [...this.regiongroups];
        tempPopulatedRegionGroups = tempPopulatedRegionGroups.filter(rg => this.populatedRegions.filter(r => rg.code == r.regiongroup).length > 0)
        return tempPopulatedRegionGroups;
      },
      populatedRegions() {
        var tempPopulatedRegions = [...this.regions];
        tempPopulatedRegions = tempPopulatedRegions.filter(r => r.contacts.length > 0);
        return tempPopulatedRegions;
      }
    }
  }

